import type { InputType } from 'config'

export function wireInstructionTemplateInputs(): Record<string, InputType> {
  return {
    accountName: {
      title: 'Account Name',
      inputType: 'text',
      required: true,
    },
    accountNumber: {
      type: 'bankAccountNo',
      title: 'Account Number',
      inputType: 'text',
      required: true,
    },
    accountAddress: {
      title: 'Account Address',
      inputType: 'textarea',
      span: 2,
      required: true,
    },
    bankName: {
      title: 'Bank Name',
      inputType: 'text',
      required: true,
    },
    bankRoutingNumber: {
      type: 'routingNo',
      title: 'Bank Routing Number',
      inputType: 'text',
      required: true,
    },
  }
}
